import apiCore from '../../utils/api-core';

export function getAllCampaigns() {
	return apiCore.get('/api/v1/campaigns');
}

export function createCampaign(data) {
	return apiCore.post('/api/v3/campaigns', data);
}

export function getAllGroups() {
	return apiCore.get('/api/v1/groups');
}

export function getCampaignById(campaignId, filter, paginate, sort) {
	return apiCore.get(
		`/api/v1/campaigns/${campaignId}/${JSON.stringify(filter)}/${paginate}/${JSON.stringify(sort)}`);
}

export function updateCampaign(campaignId, campaignUpdateDetails) {
	return apiCore.put(`/api/v1/campaigns/${campaignId}`, campaignUpdateDetails);
}

// Get contacts before the campaign starts
export function getContactsInCampaign(campaignId, paginate, sort) {
	return apiCore.get(
		`/api/v1/campaigns/get-contacts/${campaignId}/${paginate}/${JSON.stringify(sort)}`
	);
}

// Get static list of contacts from the finished campaign
export function getCampaignContacts(campaignId, paginate, sort) {
	return apiCore.get(
		`/api/v1/campaigns/get-campaign-contacts/${campaignId}/${paginate}/${sort}`
	);
}

export function getSupportedTimeZones() {
	return apiCore.get('/api/v1/timezones');
}

export function getCampaignBot(campaignId) {
	return apiCore.get(`/api/v1/campaigns/campaign-bot/${campaignId}`)
}

export function checkImportContacts(data) {
	return apiCore.post('/api/v1/contacts/check-import', data);
}

export function deleteCampaign(id) {
	return apiCore.delete(`/api/v1/campaigns/${id}`);
}

export function getCampaignsV3(params) {
    return apiCore.get('/api/v3/campaigns', { params });
}

export function getCampaignV3(id) {
    return apiCore.get(`/api/v3/campaigns/${id}`);
}

export function getCampaignContactsV3(id, params) {
    return apiCore.get(`/api/v3/campaigns/${id}/contacts`, { params });
}

export function validateCampaignV3(data) {
	return apiCore.post('/api/v3/campaigns/validate', data);
}
export function draftCampaignV3(data) {
    return apiCore.post('/api/v3/campaigns/draft', data);
}

export function updateDraftCampaignV3(id, data) {
    return apiCore.put(`/api/v3/campaigns/draft/${id}`, data);
}

export function sendDraftCampaignV3(id, data) {
    return apiCore.post(`/api/v3/campaigns/draft/${id}/send`, data);
}

export function startCampaignPreview(data) {
    return apiCore.post('/api/v3/campaigns/preview/conversations', data);
}

export function sendCampaignPreviewMessage(previewId, data) {
    return apiCore.post(`/api/v3/campaigns/preview/conversations/${previewId}/messages`, data);
}

export function resetCampaignPreview(previewId) {
    return apiCore.delete(`/api/v3/campaigns/preview/conversations/${previewId}`);
}

export function renderCampaignPreviewMessage(data) {
    return apiCore.post('/api/v3/campaigns/preview/render-message', data);
}

export function putCampaignOnHold(id) {
    return apiCore.put(`/api/v1/campaigns/${id}`, { status: 'onhold' });
}

export function resumeCampaign(id) {
    return apiCore.put(`/api/v1/campaigns/${id}`, { status: 'open' });
}

export function rescheduleCampaign(id, schedule, timezone) {
    return apiCore.put(`/api/v1/campaigns/${id}`, { schedule, timezone });
}
